import React from 'react';
import classNames from 'classnames';

import styles from '../SummaryTool.module.scss';

function UnknownPageSummary({ page }) {
  return (
    <div className={classNames(styles['page-summary'], styles['unknown'])}>
      <section>
        <h5 className={styles['capability-name']}>
          {page.title?.trim() || (
            <span className="text-muted font-italic">Untitled page</span>
          )}
        </h5>
        <div className="text-muted font-italic">
          Unknown page type: {page.type ?? '(none)'}
        </div>
      </section>
    </div>
  );
}

export default UnknownPageSummary;
